import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';
import { createSelector } from 'reselect';
import { IAppState, IPolicyScan, POLICY_SCAN_STATUS } from 'types';

export const selectPolicyScans = (state: IAppState) =>
  state.policies.policyScans;

export const selectComprehensiveByNumberPlate = createSelector(
  (state: IAppState) => state.policies.policyScans,
  (_, numberPlate: string) => numberPlate,
  (policyScans: IPolicyScan[], numberPlate: string) =>
    policyScans.find(
      (ps) =>
        ps.policyType === INSURANCE_TYPES_NAMES.VEHICLE &&
        ps.policySubTypeName === 'Comprehensive' &&
        ps.numberPlate?.toUpperCase() === numberPlate?.toLocaleUpperCase(),
    ),
);

export const selectPolicyScanById = createSelector(
  (state: IAppState) => state.policies.policyScans,
  (_, id: string) => id,
  (policyScans: IPolicyScan[], id: string) =>
    policyScans.find(R.propEq('id', id)),
);

export const selectPolicyScanStatus = createSelector(
  selectPolicyScanById,
  R.prop('status'),
);

export const selectLatestQ4EScan = createSelector(
  selectPolicyScans,
  (policyScans) => {
    return policyScans.find(
      (p) =>
        p.q4e && p.status === POLICY_SCAN_STATUS.REDIRECTED && !p.purchasedAt,
    );
  },
);

export const selectPolicyScansBySk = createSelector(
  (state: IAppState) => state.policies.policyScans,
  (_, sk: string) => sk,
  (policyScans: IPolicyScan[], sk: string) =>
    policyScans.filter(R.propEq('sk', sk)),
);

export const selectPolicyScanFromUrlById = (state: IAppState) => {
  const policyScans = state.policies.policyScans;
  const policies = state.policies.policies;
  const params = new URLSearchParams(location.search);
  const id = params.get('id') as string;

  const policyScan = policyScans.find((scan) => scan.id === id);
  if (policyScan) {
    const policy = policies.find((p) => p.id === policyScan.sk);
    policyScan.model = policy?.model;
    return policyScan;
  }
  return;
};
